<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="项目名称" name="topic_name"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button icon="add" power="b_sns_topic_edit" color="sys" @click="addTopic()">新增</c-button>
            </m-operate>

            <c-table ref="table" code="sns_topic_list">
                <c-table-column
                        label="项目名称"
                        name="topic_name"
                        width="150"
                >
                </c-table-column>

               <c-table-column
                        label="状态"
                        name="is_valid"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.is_valid == 1"><span style="color:darkgreen">启用</span></span>
                        <span v-if="data.is_valid != 1"><span style="color:#999999">禁用</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_sns_topic_edit" v-if="data.is_valid == 0"  @click="updateValid(1,data)">启用</c-table-button>
                        <c-table-button power="b_sns_topic_edit" v-if="data.is_valid == 1"  @click="updateValid(0,data)">禁用</c-table-button>
                        <c-table-button power="b_sns_topic_edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_sns_topic_edit" @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑' : '新增'" width="600" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="input" label="项目名称" name="topic_name" required word="无需输入#号"></c-form-item>
                <c-form-item type="checkbox" label="是否启用" name="is_valid" :options="isValid"></c-form-item>
                <c-form-item type="hidden" name="id"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'm_sns_topic',

        data() {
            return {
                isValid: [{
                    name: '启用',
                    value: 1
                }],
                editState: false
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/sns/topic/list',
                    data
                });
            },

            addTopic() {
                this.editState = false;
                this.$refs.editForm.clear();
                this.$refs.editDialog.open();
            },

            edit(val) {
                this.editState = true;
                let editData = Object.assign({}, val);
                editData.topic_name = editData.topic_name.substr(1, editData.topic_name.length - 2);
                this.$refs.editForm.set(editData);
                this.$refs.editDialog.open();
            },

            del(val) {
                this.$confirm({
                    text: '确定要删除【'+val.topic_name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/sns/topic/delete',
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },


            submitForm(stop) {
                stop();
                let submitUrl = '/sns/topic/add';
                if(this.editState){
                    submitUrl = '/sns/topic/edit';
                }
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        topic_name: [{
                            type: 'empty',
                            word: '请填写项目名称'
                        }]
                    },
                    dataFormatter: data => {
                        data.topic_name = '#'+data.topic_name+'#';
                        data.is_valid = data.is_valid[0];
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    },
                });
            },

            updateValid(type,val) {
                this.$confirm({
                    text: '确定要'+(type==1?'启用':'禁用')+'【'+val.topic_name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/sns/topic/valid',
                            data: {id:val.id,valid:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            }
        }
    }
</script>